import css_text from '/srv/www/htdocs/loc/app/styles/web_components/tabs.css';

export class YalwaTabs extends HTMLElement {
	static get observedAttributes() {
		return ['content_container', 'appearance'];
	}
	
	constructor() {
		super();
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this.apply_css();
		this.initialize_template();
		this.handle_click = this.handle_click.bind(this);
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text);
		this.shadowRoot.adoptedStyleSheets = [sheet];
	}
	
	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = `
				<div class="tabs" part="tabs" role="tablist">
					<slot></slot>
				</div>
			`;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.$container = jQuery(this.shadowRoot).find('.tabs');
	}
	
	connectedCallback() {
		jQuery(this).on('click', this.handle_click);
		this.render();
		jQuery(this).removeClass('invisible');
		
		const $selected = jQuery(this).find('yalwa-tab[selected="true"]');
		if ($selected.length) {
			this.sync_content($selected[0]);
		}
	}
	
	disconnectedCallback() {
		jQuery(this).off('click', this.handle_click);
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value) {
			this.render();
		}
	}
	
	render() {
		if (!this.$container || !this.$container.length) {
			return;
		}
		
		const $this = jQuery(this);
		const group_appearance = $this.attr('appearance');
		const is_secondary = (group_appearance === 'default' || $this.find('yalwa-tab[appearance="secondary"]').length);
		
		if (is_secondary) {
			this.$container.addClass('tabs--appearance_secondary');
		}
		
		if (group_appearance) {
			$this.find('yalwa-tab').each(function() {
				const $tab = jQuery(this);
				if (!$tab.attr('appearance')) {
					$tab.attr('appearance', group_appearance);
				}
			});
		}
	}
	
	handle_click(event) {
		const native_event = event.originalEvent || event;
		if (native_event.composedPath) {
			const path = native_event.composedPath();
			const tab = path.find((el) => {
				return el.tagName === 'YALWA-TAB';
			});
			
			if (tab && !jQuery(tab).is('[disabled]')) {
				this.select_tab(tab);
			}
		}
	}
	
	select_tab(selected_tab) {
		const $selected_tab = jQuery(selected_tab);
		const $all_tabs = jQuery(this).find('yalwa-tab');
		
		$all_tabs.each(function() {
			const is_selected = (this === selected_tab);
			this.setAttribute('selected', is_selected ? 'true' : 'false');
		});
		
		this.sync_content(selected_tab);
		
		this.dispatchEvent(new CustomEvent('change', {
			detail: {
				tab: selected_tab,
				value: $selected_tab.attr('value') || $selected_tab.text().trim()
			},
			bubbles: true,
			composed: true
		}));
	}
	
	sync_content(tab) {
		const $tab = jQuery(tab);
		const target_id = $tab.attr('target_id');
		const ajax_url = $tab.attr('ajax_url');
		const container_selector = jQuery(this).attr('content_container');
		
		if (target_id) {
			jQuery(this).find('yalwa-tab').each(function() {
				const t_id = jQuery(this).attr('target_id');
				if (t_id && t_id !== target_id) {
					jQuery(`#${t_id}, [data-tab-content="${t_id}"]`).addClass('hidden');
				}
			});
			jQuery(`#${target_id}, [data-tab-content="${target_id}"]`).removeClass('hidden');
		}
		
		if (ajax_url && container_selector) {
			const $container = jQuery(container_selector);
			if ($container.length) {
				$container.addClass('loading');
				jQuery.get(ajax_url, (html) => {
					$container.html(html).removeClass('loading');
				});
			}
		}
	}
}

export class YalwaTab extends HTMLElement {
	static get observedAttributes() {
		return ['selected', 'appearance', 'disabled'];
	}
	
	constructor() {
		super();
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open', delegatesFocus: true});
		}
		this.apply_css();
		this.initialize_template();
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text);
		this.shadowRoot.adoptedStyleSheets = [sheet];
	}
	
	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = `
				<button class="tab" part="tab" role="tab" type="button">
					<slot></slot>
				</button>
			`;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.$button = jQuery(this.shadowRoot).find('button');
	}
	
	connectedCallback() {
		this.render();
		jQuery(this).removeClass('invisible');
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value) {
			this.render();
		}
	}
	
	render() {
		if (!this.$button || !this.$button.length) {
			this.initialize_template();
			if (!this.$button || !this.$button.length) {
				return;
			}
		}
		
		const selected = (this.getAttribute('selected') === 'true');
		const appearance = (this.getAttribute('appearance') || 'default');
		const disabled = this.hasAttribute('disabled');
		
		this.$button.attr({
			'aria-selected': (selected ? 'true' : 'false'),
			'data-selected': (selected ? 'true' : 'false'),
			'data-appearance': appearance
		});
		
		if (disabled) {
			this.$button.attr('disabled', '');
		} else {
			this.$button.removeAttr('disabled');
		}
	}
}

if (!customElements.get('yalwa-tabs')) {
	customElements.define('yalwa-tabs', YalwaTabs);
}
if (!customElements.get('yalwa-tab')) {
	customElements.define('yalwa-tab', YalwaTab);
}
